import { SignIn, useAuth } from "@clerk/clerk-react";
import { Navigate } from "@tanstack/react-router";
import { clerkAppearance } from "../clerkAppearance";
import { AuthShell } from "./AuthShell";

/** Public, full-screen sign-in. Clerk handles the flow; we style it to Cendre. */
export function SignInPage() {
  const { isLoaded, isSignedIn } = useAuth();
  if (isLoaded && isSignedIn) return <Navigate to="/chat" />;

  return (
    <AuthShell>
      <SignIn
        routing="hash"
        signUpUrl="/sign-up"
        fallbackRedirectUrl="/chat"
        appearance={clerkAppearance}
      />
    </AuthShell>
  );
}
